import type {
  CreateWebclientConfigRequestDto,
  GetWebclientResponseDto,
  UpdateWebclientConfigRequestDto,
  WebclientPreviewDTO,
} from '@conversed/shared/src/central/dto/webclient-config.dto';

import { ENDPOINTS } from '../constants/apiEndpoints';
import { axiosInterceptAccessTokenExpiry } from './axios/axiosIntercepted';
import type { TGeneralResponse } from './dto/common.dto';

export const getWebclientConfigsEndpoint =
  (): TGeneralResponse<GetWebclientResponseDto> =>
    axiosInterceptAccessTokenExpiry().get(`${ENDPOINTS.WEBCLIENT}/configs`);

export const createWebclientConfigEndpoint = (
  name: string,
  config: CreateWebclientConfigRequestDto['config'],
): TGeneralResponse =>
  axiosInterceptAccessTokenExpiry().post(`${ENDPOINTS.WEBCLIENT}/configs`, {
    name,
    config,
  });

export const createWebclientEndpoint = (): TGeneralResponse =>
  axiosInterceptAccessTokenExpiry().post(`${ENDPOINTS.WEBCLIENT}`);

export const updateWebclientConfigEndpoint = (
  identifier: string,
  name: string,
  config: UpdateWebclientConfigRequestDto['config'],
): TGeneralResponse =>
  axiosInterceptAccessTokenExpiry().put(
    `${ENDPOINTS.WEBCLIENT}/configs/${identifier}`,
    {
      name,
      config,
    },
  );

export const deleteWebclientConfigEndpoint = (
  identifier: string,
): TGeneralResponse =>
  axiosInterceptAccessTokenExpiry().delete(
    `${ENDPOINTS.WEBCLIENT}/configs/${identifier}`,
  );

export const addWebclientWhitelistEndpoint = (
  domain: string,
): TGeneralResponse =>
  axiosInterceptAccessTokenExpiry().post(`${ENDPOINTS.WEBCLIENT}/whitelist`, {
    domain,
  });

export const removeWebclientWhitelistedDomainEndpoint = (
  domain: string,
): TGeneralResponse =>
  axiosInterceptAccessTokenExpiry().delete(`${ENDPOINTS.WEBCLIENT}/whitelist`, {
    params: { domain },
  });

export const setWebclientConfigStatusEndpoint = (
  id: string,
  status: boolean,
): TGeneralResponse =>
  axiosInterceptAccessTokenExpiry().put(
    `${ENDPOINTS.WEBCLIENT}/configs/status/${id}`,
    { status },
  );

export const setWebclientConfigDefaultEndpoint = (
  id: string,
): TGeneralResponse =>
  axiosInterceptAccessTokenExpiry().put(
    `${ENDPOINTS.WEBCLIENT}/configs/default/${id}`,
  );

export const getWebclientPreviewConfigEndpoint =
  (): TGeneralResponse<WebclientPreviewDTO> =>
    axiosInterceptAccessTokenExpiry().get(
      `${ENDPOINTS.WEBCLIENT}/preview-configs`,
    );
